module.exports = __webpack_public_path__ + "img/cj-648.ee6380b2.png";